import React, { useEffect } from 'react'
import "../css/HomePageGridImage.css"

import { gsap } from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
import * as imagesdata from '../imagesdata'
gsap.registerPlugin(ScrollTrigger);

const GridImage = () => {

    useEffect(() => {

        gsap.fromTo(".grid-image-div1",
            { opacity: 0, x: -100 },
            {
                opacity: 1, x: 0, duration: 1, delay: 0 * 0.1, ease: "power2.out",
                scrollTrigger: {
                    trigger: ".grid-image-div1",
                    start: "top center",
                    toggleActions: "play none none none",
                }
            }
        );

        gsap.fromTo(".grid-image-div2",
            { opacity: 0, x: 100 },
            {
                opacity: 1, x: 0, duration: 1, delay: 1 * 0.1, ease: "power2.out",
                scrollTrigger: {
                    trigger: ".grid-image-div2",
                    start: "top center",
                    toggleActions: "play none none none",
                }
            }
        );

        gsap.fromTo(".grid-image-div3",
            { opacity: 0, x: window.innerWidth < 750 ? -100 : 100 },
            {
                opacity: 1, x: 0, duration: 1, delay: 2 * 0.1, ease: "power2.out",
                scrollTrigger: {
                    trigger: ".grid-image-div3",
                    start: "top center",
                    toggleActions: "play none none none",
                }
            }
        );

        gsap.fromTo(".grid-image-div4",
            { opacity: 0, x: 100 },
            {
                opacity: 1, x: 0, duration: 1, delay: 3 * 0.1, ease: "power2.out",
                scrollTrigger: {
                    trigger: ".grid-image-div4",
                    start: "top center",
                    toggleActions: "play none none none",
                }
            }
        );

    }, []);

    return (
        <div>
            <div className='grid-image-text-header'>
                <h3 className='grid-image-text'>- Sayfalarımız -</h3>
            </div>
            <div class="grid-image-parent">
                <div class="grid-image-div1">
                    <img src={imagesdata.GridProduct} />
                    <h4>Trafik Akışımıza <br /> <a href='/trafik-akisi'>Göz Atın</a></h4>
                </div>
                <div class="grid-image-div2">
                    <img src={imagesdata.GridDoor} />
                    <h4>Kim Olduğumuzu <br /> <a href='/biz-kimiz'>Öğrenin</a></h4>
                </div>
                <div class="grid-image-div3">
                    <img src={imagesdata.GridFrame} />
                    <h4>Ürün Detaylarına <br /> <a href='/surecler'>Göz Atın</a></h4>
                </div>
                <div class="grid-image-div4">
                    <img src={imagesdata.GridJamb} />
                    <h4>Referanslarımıza <br /> <a href='/referanslar'>Göz Atın</a></h4>
                </div>
            </div>
        </div>
    )
}

export default GridImage